import { useMutation } from "@tanstack/react-query";

import api from "../apiClient";

import cookiesHelper from "../../helpers/cookies";

interface IUseExportPageViewsReportProps {
    payload: {
        filterQuery: string;
    }
}

const useExportPageViewsReport = () => {
    const mutationFn = async (variables: IUseExportPageViewsReportProps) => {
        const token = cookiesHelper.getCookie((process.env.REACT_APP_AUTH_TOKEN_NAME as string));
        api.defaults.headers.common['Authorization'] = `Bearer ${token}`;

        const response = await api.get(`analytics/page-views-report/csv?${variables.payload.filterQuery}`, { responseType: 'stream' });
        return response.data;
    };

    return useMutation({
        mutationFn,
        retry: 0,
        onSuccess: async (data) => {
            const blob = new Blob([data], { type: 'text/csv' });
            const url = window.URL.createObjectURL(blob);

            const a = document.createElement('a');
            a.href = url;
            a.download = 'page_views_report.csv';
            document.body.appendChild(a);
            a.click();
            a.remove();
            window.URL.revokeObjectURL(url);
        },
        onError: () => { },
    });
};

export default useExportPageViewsReport;